<template>
<div class="container">
    <img class="container-bg-style" :src="Images.img_page_bg2" alt="">
    <scroller :on-refresh="_onRefresh" :on-infinite="_onEndReached" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
        <div class="content-item-wrap amount-info-wrap">
            <div class="amount-info-item">
                <div class="value">
                    <span class="unit mr-1">¥</span>
                    <span class="text">{{dataSources.withdrawal || 0}}</span>
                </div>
                <div class="title">当前可提现金额</div>
            </div>

            <div class="amount-info-item total-withdraw-info flex rcs">
                <div class="title">当前累计提现金额：</div>
                <div class="value">
                    <span class="text">{{dataSources.withdrawal_total || 0}}</span>
                    <span class="unit">元</span>
                </div>
            </div>

        </div>

        <div class="content-item-wrap withdraw-style-wrap">
            <div class="flex rcb style-item-wrap" v-for="(item, index) in navArray" :key="index" @click="_onPressToNavigate(item.title, 'withdrawalApply', {type: item.type, account_type, amount: dataSources.withdrawal})">
                <div class="pic-wrap style-icon-wrap">
                    <img :src="item.icon" class="pic-img style-icon" />
                </div>
                <div class="style-info-wrap flex rcb">
                    <div class="title-info-wrap">
                        <div class="title">{{item.title}}  {{item.limit}}</div>
                        <div class="desc" v-if="dataSources.show_desc > 0">{{item.desc}}</div>
                    </div>
                    <div class="right-icon-wrap">
                        <img :src="Images.icon_arrow_right3" class="right-icon" />
                    </div>
                </div>
            </div>
        </div>

        <div class="content-item-wrap history-info-wrap">
            <div class="content-title-wrap flex rcs">
                <img :src="Images.icon_amount_record" alt="" class="title-icon">
                <div class="title">提现记录</div>
            </div>
            <withdraw-record-item v-for="(item, index) in listData" :key="index" :item="item" />
            <van-empty description="暂无信息～" v-if="listData.length < 1 && !loading" />
        </div>
    </scroller>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import WithdrawRecordItem from '../../components/item/WithdrawRecordItem';
export default {
    components: {
        WithdrawRecordItem
    },
    computed: {
        ...mapGetters(["userInfo"]),
        navArray() {
            if (this.user_type == this.Constants.USER_MASTER) {
                return this.masterNavArray;
            }
            return this.agentNavArray;
        }
    },
    data() {
        return {
            loading: false,
            account_type: this.$route.query.account_type || this.Constants.ACCOUNT_CLASS,
            user_type: this.$route.query.user_type || this.Constants.USER_MASTER,
            page: 0,
            limit: 10,
            listData: [],
            dataSources: {},
            agentNavArray: [],
            masterNavArray: [],
        }
    },
    mounted() {
        this._requestNavDataSources();
        this._requestDataSources();

    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        async _requestNavDataSources() {
            let url = this.API.withdrawal_config;
            let data = {
                user_type: this.user_type,
                account_type: this.account_type,
            };
            const result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
                this.agentNavArray = result.data.agentNavArray;
                this.masterNavArray = result.data.masterNavArray;
            }
        },

        async _requestDataSources() {
            let url = this.API.withdrawal_record;
            let data = {
                page: this.page,
                limit: this.limit,
                account_type: this.account_type,
            };
            try {
                this.loading = true;
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.listData.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.listData = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                console.log('error---->', error);
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status, this.dataSources);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
    beforeRouteLeave(to, from, next) {
        console.log('to, from', to, from)
        // 设置下一个路由的 meta
        if (to.query.pageTitle) {
            to.meta.title = to.query.pageTitle + '提现';
        }
        next();
    }
}
</script>

<style lang="less" scoped>
.container {
    .container-bg-style {
        top: 0;
        z-index: 0;
        width: 100%;
        position: absolute;
    }

    .content-item-wrap {
        padding: 1rem 1.5rem;

        .content-title-wrap {
            margin-bottom: 2rem;

            .title-icon {
                width: 2.4rem;
                margin-right: 1rem;
            }

            .title {
                font-size: 1.5rem;
                font-weight: 600;
            }
        }
    }

    .amount-info-wrap {
        margin: 1.5rem 0 0;

        .amount-info-item {
            color: #fff;
            font-size: 1.4rem;
            text-align: center;

            .title {}

            .value {
                font-size: 2.4rem;
                margin-bottom: 1rem;
            }
        }

        .total-withdraw-info {
            background: #fff;
            margin: 1.5rem 0 0;
            padding: 2rem 1.5rem;
            border-radius: .5rem;

            .title {
                color: #333;
            }

            .value {
                margin-bottom: 0;
                color: #4994fc;
                .unit {
                    font-size: 1.6rem;
                    margin-left: .2rem;
                }
            }
        }
    }

    .withdraw-style-wrap {
        padding-bottom: 0;

        .style-item-wrap {
            background: #fff;
            min-height: 3rem;
            padding: 1rem 1.5rem;
            border-radius: .5rem;
            margin-bottom: 1.5rem;

            .style-icon-wrap {
                width: 3.5rem;

                .style-icon {}
            }

            .style-info-wrap {
                flex: 1;
                margin-left: 1.5rem;

                .title-info-wrap {

                    .title {
                        font-weight: 600;
                        font-size: 1.4rem;
                    }

                    .desc {
                        color: #666;
                        font-size: 1.2rem;
                        margin-top: .5rem;
                    }
                }

                .right-icon-wrap {
                    width: 1rem;

                    img.right-icon {}
                }
            }
        }
    }

    .history-info-wrap {}

}
</style>
